<!-- ThemeToggle.vue -->
<template>
  <Button v-if="theme === 'light'" icon="pi pi-sun" variant="outlined" @click="toggleTheme" />
  <Button v-else icon="pi pi-moon" variant="outlined" @click="toggleTheme" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Button from 'primevue/button';

import { useThemeStore } from '@/stores/theme';

const themeStore = useThemeStore();
const theme = computed(() => themeStore.theme);
const toggleTheme = () => {
  themeStore.toggleTheme();
};
</script>
